import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import sanityClient from '../client.js'

const Post = () => {
	const [postData, setPostData] = useState(null)

	useEffect(() => {
		sanityClient
			.fetch(
				`*[_type =='post']{
			title,
			slug,
			mainImage{
				asset->{
					_id,
					url
				},
				alt
			}
		}`
			)
			.then((data) => setPostData(data))
			.catch(console.error)
	}, [])

	return (
		<main className='bg-primary-200 min-h-screen p-12'>
			<section className='container mx-auto'>
				<h1 className='text-5xl flex justify-center cursive'>Posts</h1>
				<h2 className='text-lg text-gray-800 flex justify-center mb-12'>
					Welcome to our posts, each on different ideas and challanges.
				</h2>
				<div className='grid md:grid-cols-2 lg:grid-cols-3 gap-8'>
					{postData &&
						postData.map((post, index) => {
							return (
								<article key={index}>
									<Link
										to={'/post/' + post.slug.current}
										key={post.slug.current}>
										<span className='block h-64 relative rounded leading-snug border-l-8 border-primary-500'>
											<img
												src={post.mainImage.asset.url}
												alt={post.mainImage.alt}
												className='w-full h-full rounded-r object-cover absolute'
											/>
											<span className='block h-full relative flex justify-end items-end pr-4 pb-4'>
												<h3 className=' font-bold px-3 py-4 bg-primary-900 text-secondary-200 bg-opacity-75 rounded'>
													{post.title}
												</h3>
											</span>
										</span>
									</Link>
								</article>
							)
						})}
				</div>
			</section>
		</main>
	)
}

export default Post
